export default __webpack_public_path__ + "static/media/80d2958905e9e07475d2a85e42ebac18.png";